import {Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {
	UpdateCustomFieldDefinitionInput,
	UpdateCustomFieldDefinitionMutation,
	UpdateCustomFieldDefinitionMutation$rawResponse,
} from './__generated__/UpdateCustomFieldDefinitionMutation.graphql';
import type {Disposable} from 'relay-runtime';

const mutation = graphql`
	mutation UpdateCustomFieldDefinitionMutation($input: UpdateCustomFieldDefinitionInput!) @raw_response_type {
		updateCustomFieldDefinition(input: $input) {
			customFieldDefinition {
				node {
					id
					displayName
					readOnly
					avaRef
				}
			}
		}
	}
`;

function getOptimisticResponse(input: UpdateCustomFieldDefinitionInput): UpdateCustomFieldDefinitionMutation$rawResponse {
	return {
		updateCustomFieldDefinition: {
			customFieldDefinition: {
				node: {
					id: input.id,
					displayName: input.displayName,
					readOnly: input.readOnly,
					avaRef: input.avaRef,
				},
			},
		},
	} as UpdateCustomFieldDefinitionMutation$rawResponse;
}
function commit(
	environment: Environment,
	input: MutationInput<UpdateCustomFieldDefinitionInput>,
	onSuccess: RelayOnCompleted<UpdateCustomFieldDefinitionMutation>,
	onError: RelayOnError
): Disposable {
	tracking.trackEvent('CustomFieldDefinition - Updated');

	return trackAndCommitMutation<UpdateCustomFieldDefinitionMutation>(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
